/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboxMessageUpdate
 */
export interface InboxMessageUpdate {
    /**
     * 
     * @type {string}
     * @memberof InboxMessageUpdate
     */
    header: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageUpdate
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageUpdate
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageUpdate
     */
    language_code: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageUpdate
     */
    id: string;
}

/**
 * Check if a given object implements the InboxMessageUpdate interface.
 */
export function instanceOfInboxMessageUpdate(value: object): value is InboxMessageUpdate {
    if (!('header' in value) || value['header'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function InboxMessageUpdateFromJSON(json: any): InboxMessageUpdate {
    return InboxMessageUpdateFromJSONTyped(json, false);
}

export function InboxMessageUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboxMessageUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'],
        'message': json['message'],
        'name': json['name'],
        'url': json['url'],
        'language_code': json['language_code'],
        'id': json['id'],
    };
}

export function InboxMessageUpdateToJSON(json: any): InboxMessageUpdate {
    return InboxMessageUpdateToJSONTyped(json, false);
}

export function InboxMessageUpdateToJSONTyped(value?: InboxMessageUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'message': value['message'],
        'name': value['name'],
        'url': value['url'],
        'language_code': value['language_code'],
        'id': value['id'],
    };
}

